import React, { ReactElement } from 'react';
import Styled from './Container.styled';
import { ComponentProps, DEFAULT_MAX_WIDTH } from './Container.types';
import { SpaceProps } from 'styled-system';

const NavContainer: React.FC<ComponentProps & SpaceProps> = ({
  maxWidth = DEFAULT_MAX_WIDTH,
  children,
  ...props
}): ReactElement<ComponentProps> => {
  return (
    <Styled maxWidth={maxWidth} {...props}>
      {children}
    </Styled>
  );
};

export default NavContainer;
